"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportModel = void 0;
const backwardCompatChart_1 = __importDefault(require("@opsbase/lib-chart/helpers/backwardCompatChart"));
const backwardCompatQuery_1 = __importDefault(require("@opsbase/lib-data-query/helpers/backwardCompatQuery"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_logger_1 = __importDefault(require("@opsbase/lib-logger"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
function cleanUp(type, state) {
    var _a;
    if (!state)
        return;
    if (!state.type)
        state.type = type;
    if (!state.hideEmptyGroups)
        state.hideEmptyGroups = false;
    (0, backwardCompatQuery_1.default)(state);
    if (state.highlightedGroups) {
        delete state.highlightedGroups;
    }
    if (!state.chartBox) {
        state.chartBox = { visible: false, charts: [] };
    }
    else if ((_a = state.chartBox) === null || _a === void 0 ? void 0 : _a.charts) {
        state.chartBox.charts.forEach(backwardCompatChart_1.default);
    }
}
class ReportModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.isOwned = true;
        this.isShared = false;
        super.init(o);
        if (o === null || o === void 0 ? void 0 : o.state) {
            try {
                this.state = JSON.parse(o.state);
                cleanUp(this.type, this.state);
            }
            catch (err) {
                lib_logger_1.default.error('Problem cleaning up report', { err, o });
            }
        }
    }
    get __typename() {
        return 'Report';
    }
    set __typename(v) {
    }
}
exports.ReportModel = ReportModel;
ReportModel.ALL_FIELDS = `id, title, type, state, isShared, isOwned`;
exports.default = ReportModel;
ModelRegistry_1.default[DataType_1.default.REPORT] = ReportModel;
